<template>
  <section id="contactanos" class="contactanos-wrapper">
    <!-- Título con fondo propio -->
    <div class="titulo-section">
      <h2 class="titulo">Contáctanos</h2>
    </div>

    <div class="content">
      <!-- Izquierda: Información de contacto en tarjetas separadas -->
      <div class="contacto-section">
        <div class="info-card">
          <div class="icon">📍</div>
          <div class="info-text">
            <h4>Ubicación</h4>
            <p>
              Calle 30 con Avenida 33<br>
              Centro Comercial Latin Center P/B<br>
              Local 01 Sector Centro<br>
              Acarigua, Estado Portuguesa, Venezuela
            </p>
          </div>
        </div>
        <div class="info-card">
          <div class="icon">📞</div>
          <div class="info-text">
            <h4>Teléfono</h4>
            <p>0412-5696219</p>
            <p>0416-7594723</p>
          </div>
        </div>
        <div class="info-card">
          <div class="icon">✉️</div>
          <div class="info-text">
            <h4>Correo electrónico</h4>
            <p>soportejeaninformatico@gmail.com</p>
            <p>jeaninformaticoca@gmail.com</p>
          </div>
        </div>
        <div class="info-card">
          <div class="icon">⏰</div>
          <div class="info-text">
            <h4>Horario</h4>
            <p>8:00 AM A 6:00 PM</p>
          </div>
        </div>
      </div>

      <!-- Derecha: Formulario -->
      <div class="form-section">
        <h2>Envíanos un mensaje</h2>
        <form @submit.prevent="sendToWhatsApp">
          <input type="text" v-model="form.nombre" placeholder="Nombre completo*" required />
          <input type="email" v-model="form.email" placeholder="Correo electrónico*" required />
          <input type="tel" v-model="form.telefono" placeholder="Teléfono*" required />
          <input type="text" v-model="form.empresa" placeholder="Empresa (opcional)" />
          <select v-model="form.servicio" required>
            <option disabled value="">Seleccione un servicio</option>
            <option>Reparación de pantalla</option>
            <option>Cambio de batería</option>
            <option>Diagnóstico general</option>
          </select>
          <textarea v-model="form.mensaje" placeholder="Tu mensaje..." rows="4"></textarea>
          <button type="submit" class="btn-enviar">Deseo ser contactado</button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactanoWien",
  data() {
    return {
      form: {
        nombre: "",
        email: "",
        telefono: "",
        fecha: "",
        servicio: "",
        mensaje: "",
      },
      whatsappNumber: "584125696219",
    };
  },
  methods: {
    sendToWhatsApp() {
      const mensaje = `👤 Nueva Cita
Nombre: ${this.form.nombre}
Correo: ${this.form.email}
Teléfono: ${this.form.telefono}
Fecha: ${this.form.fecha}
Servicio: ${this.form.servicio}
Mensaje: ${this.form.mensaje}`;

      const url = `https://wa.me/${this.whatsappNumber}?text=${encodeURIComponent(
        mensaje
      )}`;
      window.open(url, "_blank");
      this.resetForm();
    },
    resetForm() {
      this.form = {
        nombre: "",
        email: "",
        telefono: "",
        fecha: "",
        servicio: "",
        mensaje: "",
      };
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;800&display=swap');

/* ===== ENVOLTORIO ===== */
.contactanos-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: #030812;
  font-family: 'Poppins', sans-serif;
  padding-bottom: 5rem;
  
  /* 🔴 ELIMINA EL CHOQUE CON EL NAVBAR */
  padding-top: 100px; 
}

/* ===== TÍTULO ===== */
.titulo-section {
  position: relative;
  width: 100%;
  background: url('../assets/fondoontactanos.jpg') no-repeat center center/cover;
  text-align: center;
  padding: 6rem 2rem; /* Más espacio para que el título respire */
  display: flex;
  justify-content: center;
  align-items: center;
}

.titulo-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(3, 8, 18, 0.8), rgba(3, 8, 18, 0.95));
}

.titulo {
  position: relative;
  z-index: 1;
  font-size: 3rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0;
  text-shadow: 0 0 20px rgba(0, 229, 255, 0.4);
  letter-spacing: 1px;
}

/* ===== CONTENEDOR ===== */
.content {
  display: flex;
  gap: 2rem;
  width: 100%;
  max-width: 1200px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 4rem; /* Separación entre el título y las tarjetas */
  padding: 0 1.5rem;
  position: relative;
  z-index: 10;
}

/* ===== TARJETAS DE INFORMACIÓN ===== */
.contacto-section {
  flex: 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: rgba(10, 18, 30, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid rgba(0, 229, 255, 0.15);
  text-align: left;
  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.info-card:hover {
  transform: translateY(-3px);
  border-color: rgba(0, 229, 255, 0.5);
  box-shadow: 0 5px 20px rgba(0, 229, 255, 0.1);
}

.info-card .icon {
  font-size: 1.8rem;
  margin: 0;
  flex-shrink: 0;
  line-height: 1;
  filter: drop-shadow(0 0 5px rgba(0, 229, 255, 0.4));
}

.info-text h4 {
  margin: 0 0 0.5rem 0;
  font-weight: 700;
  color: #00e5ff;
}

.info-text p {
  margin: 0.2rem 0;
  color: #b9c9d9;
  line-height: 1.5;
  font-size: 0.95rem;
}

/* ===== FORMULARIO ===== */
.form-section {
  flex: 1;
  min-width: 300px;
  background: rgba(10, 18, 30, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 2.5rem;
  border-radius: 12px;
  border: 1px solid rgba(0, 229, 255, 0.15);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.form-section h2 {
  color: #ffffff;
  font-size: 1.5rem;
  margin-top: 0;
  margin-bottom: 1.5rem;
  text-shadow: 0 0 10px rgba(0, 229, 255, 0.2);
}

form input,
form select,
form textarea {
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.9rem;
  border-radius: 8px;
  border: 1px solid rgba(0, 229, 255, 0.2);
  background: rgba(3, 8, 18, 0.8);
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  transition: all 0.3s ease;
}

form input::placeholder,
form textarea::placeholder {
  color: #6b7d8f;
}

form input:focus,
form select:focus,
form textarea:focus {
  outline: none;
  border-color: #00e5ff;
  box-shadow: 0 0 15px rgba(0, 229, 255, 0.2);
  background: rgba(3, 8, 18, 1);
}

form select option {
  background-color: #0a121e;
  color: #ffffff;
}

/* Botón */
.btn-enviar {
  width: 100%;
  padding: 1rem;
  background: linear-gradient(135deg, #00e5ff, #1a73e8);
  color: #04121a;
  font-weight: 700;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 0 15px rgba(0, 229, 255, 0.3);
}

.btn-enviar:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 25px rgba(0, 229, 255, 0.6);
}

/* ===== RESPONSIVE ===== */
@media (max-width: 900px) {
  .content {
    flex-direction: column;
    align-items: center;
    margin-top: 3rem;
  }
  
  .info-card,
  .form-section {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .titulo {
    font-size: 2rem;
  }
  
  .form-section {
    padding: 1.5rem;
  }
}
</style>